import * as yup from 'yup';

export const yupSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().email().required(),
  timezone: yup.string().required(),
});
